import React from 'react';
import { useTheme } from 'styled-components';

/* Styled Components */
import { Radio, RadioDot } from 'styles/common/WishRadioGroup';

import {
  Title,
  TitleWrapper,
  ColumnWrapper,
  ContentWrapper,
  RadioBox as StyledRadioBox,
} from 'styles/signup/BlueRadioBox';

type PropsType = {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  selected: boolean;
  onClick: () => void;
};

const RadioBox = ({
  title,
  description,
  icon,
  selected,
  onClick,
}: PropsType) => {
  const theme = useTheme();

  return (
    <StyledRadioBox selected={selected} onClick={onClick}>
      <Radio selected={selected} borderColor={theme.darkCobalt}>
        <RadioDot selected={selected} color={theme.darkCobalt} />
      </Radio>
      <ColumnWrapper>
        <TitleWrapper>
          {icon}
          <Title>{title}</Title>
        </TitleWrapper>
        <ContentWrapper>{description}</ContentWrapper>
      </ColumnWrapper>
    </StyledRadioBox>
  );
};

export default RadioBox;
